export const refreshSearchFeatureName = 'refreshSearch';

export type RefreshSearchState = Readonly<{
  refreshTimer: boolean,
}>;
